import { union } from 'lodash'

class BusinessService {
  businessName(business = {}) {
    const { businessName = '' } = business || {}
    return businessName
  }

  createdBy(business = {}) {
    const { createdBy = '' } = business || {}
    return createdBy
  }

  businessType(business = {}) {
    const { businessType = '' } = business || {}
    return businessType
  }

  numberOfEmployees(business = {}) {
    const { numberOfEmployees } = business || {}
    return numberOfEmployees
  }

  untaxedIncome(business = {}) {
    const { untaxedIncome = 0 } = business || {}
    return untaxedIncome
  }

  estimatedIncome(business = {}) {
    const { estimatedIncome = 0 } = business || {}
    return estimatedIncome
  }

  easeOfCollection(business = {}) {
    const { easeOfCollection = 0 } = business || {}
    return easeOfCollection
  }

  isNonFiler(business = {}) {
    const { nonFiler = false } = business || {}
    return nonFiler
  }

  isUnderReport(business = {}) {
    const { underReport = false } = business || {}
    return underReport
  }

  websiteLinks(business = {}) {
    const { websiteLinks = [] } = business || {}
    return Object.fromEntries(Object.entries(websiteLinks).filter(([k, v]) => !!v))
  }

  projects(business = {}) {
    const { revenueIndicationsV2 } = business || {}
    return revenueIndicationsV2 || []
  }

  reviews(business = {}) {
    const { reviewsV3 = [] } = business || {}
    return reviewsV3 || []
  }

  numberOfReviews(business = {}) {
    const { reviewsCount = 0 } = business || {}
    return reviewsCount
  }

  dataSources(business = {}) {
    const { createdBy } = business
    const createdBySource = createdBy && createdBy.toLowerCase()

    const projectSources = this.projects(business).map(project => project.reviewSource)
    const reviewSources = this.reviews(business).map(review => review.reviewSource)

    const websiteLinks = Object.keys(this.websiteLinks(business))

    const allDataSources = union([createdBySource], projectSources, reviewSources, websiteLinks)
    if (allDataSources.includes('gmaps') && allDataSources.includes('google maps'))
      return allDataSources.filter(source => !!source && source !== 'google maps')
    return allDataSources.filter(source => !!source)
  }
}

export default new BusinessService()
